import React from 'react';
import PropTypes from 'prop-types';

import Dialog, { DialogTitle } from '../../common/Dialog';
import GroupParticipantsList from './GroupParticipantsList.container';
import GroupParticipantsDialogContent from './ViewGroupParticipantsDialog.styled';

const ViewGroupParticipantsDialog = ({ open, onClose, groupId }) => (
  <Dialog id="view-participants" open={open} onClose={onClose} height="700">
    <DialogTitle id="view-participants-dialogtitle" onClose={onClose}>
      View Participants
    </DialogTitle>
    <GroupParticipantsDialogContent>
      <GroupParticipantsList groupId={groupId} />
    </GroupParticipantsDialogContent>
  </Dialog>
);

ViewGroupParticipantsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  groupId: PropTypes.string.isRequired,
};

export default ViewGroupParticipantsDialog;
